"use client";

import { Link } from "@tanstack/react-router";

import { Button } from "#/components/ui/button";

import type { HiscoreRow } from "./-hiscores.ui";
import { MarqueeViewport } from "./-index.monthlyHiscoresMarquee.viewport";

const shortMonthFormatter = new Intl.DateTimeFormat("en-US", {
  month: "short",
  timeZone: "UTC",
});

function formatShortMonthLabel(monthKey: string): string {
  const year = Number(monthKey.slice(0, 4));
  const monthIndex = Number(monthKey.slice(5, 7)) - 1;
  return shortMonthFormatter.format(new Date(Date.UTC(year, monthIndex, 1))).toUpperCase();
}

export function MonthlyHiscoresMarquee({
  entries,
  monthKey,
}: {
  entries: HiscoreRow[];
  monthKey: string;
}) {
  if (entries.length === 0) return null;

  const monthLabel = formatShortMonthLabel(monthKey);

  return (
    <div
      className="flex w-full items-center gap-3 overflow-hidden border border-border bg-card py-2 pr-2 pl-3"
      aria-label={`${monthLabel} top 10 hiscores`}
    >
      <span className="flex shrink-0 flex-col items-center text-center text-[0.65rem] leading-tight font-semibold tracking-wide text-muted-foreground uppercase">
        <span>{monthLabel}</span>
        <span>Top 10</span>
      </span>
      <MarqueeViewport entries={entries} />
      <Button
        size="icon-sm"
        className="shrink-0"
        aria-label="View hiscores"
        render={<Link to="/hiscores" search={{ month: monthKey }} preload={false} />}
        nativeButton={false}
      >
        →
      </Button>
    </div>
  );
}
